import React, { useEffect } from "react";
import { Select, Flex, InputNumber } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const CustomPagination = ({
  page,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange,
  maxPageSize,
}) => {
  useEffect(() => {
    if (page > totalPages) {
      onPageChange(totalPages);
    }
  }, [totalPages, page]);

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    onPageChange(newPage);
  };

  return (
    <Flex align="center" gap={12}>
      {/* <Flex align="center" gap={6}>
        <span style={{ fontSize: "13px", fontWeight: "600" }}>Page Size:</span>
        <InputNumber
          min={1}
          max={maxPageSize}
          parser={(value) => value.replace(/\D/g, "")} 
          formatter={(value) => (value ? Math.min(value, maxPageSize) : 1)} 
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault();
            }
          }}
          value={pageSize}
          onChange={onPageSizeChange}
          style={{
            width: "60px",
            textAlign: "center",
            background: "#f5f5f5",
            borderRadius: "8px",
            fontSize: "13px",
          }}
        />
      </Flex> */}

      <Flex
        align="center"
        gap={4}
        style={{ cursor: page === 1 ? "not-allowed" : "pointer" }}
        onClick={() => handlePageChange(page - 1)}
      >
        <LeftOutlined
          style={{
            fontSize: "13px",
            color: page === 1 ? "#ccc" : "#000",
          }}
        />
        <span
          style={{
            fontSize: "13px",
            fontWeight: "600",
            color: page === 1 ? "#ccc" : "#000",
          }}
        >
          Prev
        </span>
      </Flex>

      <Select
        value={page}
        onChange={handlePageChange}
        popupClassName="custom-dropdown"
        style={{
          minWidth: "60px",
          textAlign: "center",
          background: "#f5f5f5",
          borderRadius: "8px",
          fontSize: "13px",
        }}
      >
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
          <Select.Option key={pageNum} value={pageNum}>
            {pageNum}
          </Select.Option>
        ))}
      </Select>

      <span style={{ fontSize: "13px", fontWeight: "600" }}>
        of {totalPages}
      </span>

      <Flex
        align="center"
        gap={4}
        style={{ cursor: page === totalPages ? "not-allowed" : "pointer" }}
        onClick={() => handlePageChange(page + 1)}
      >
        <span
          style={{
            fontSize: "13px",
            fontWeight: "600",
            color: page === totalPages ? "#ccc" : "#000",
          }}
        >
          Next
        </span>
        <RightOutlined
          style={{
            fontSize: "13px",
            color: page === totalPages ? "#ccc" : "#000",
          }}
        />
      </Flex>
    </Flex>
  );
};

export default CustomPagination;
